var site = site || {};

site.giftcards = site.giftcards || {};

(function ($) {
  site.giftcards.initCheckBalance = function (context) {
    var formNode = $('form', context);

    if (!formNode[0]) {
      return null;
    }

    var setLoadBtnState = function ($form) {
      $('.check-balance-btn', $form).hide();
      $('.add-progress', $form).show();
    };
    var setDefaultBtnState = function ($form) {
      $('.check-balance-btn', $form).show();
      $('.add-progress', $form).hide();
    };

    setDefaultBtnState(formNode);
    formNode.on('submit', function (evt) {
      var $this_form = $(this);
      var $error_node = $('.error_messages', $this_form);

      evt.preventDefault();
      setLoadBtnState($this_form);
      var gcValue = $this_form.find('input[name=GC_GIFTCARD_NUMBER]').val();
      var gcPin = $this_form.find('input[name=GC_GIFTCARD_PIN]').val();
      var $remaingBalanceNode = $('.remaining-balance', $this_form);

      site.giftcards.balance.fetchBalance({
        giftcardNumber: gcValue,
        giftcardPin: gcPin,
        errorListNode: $error_node,
        onSuccess: function (responseData) {
          $error_node.addClass('hidden');
          var balance = responseData.formatted_balance;

          setDefaultBtnState($this_form);
          $remaingBalanceNode.find('.giftcard-balance__value').html(balance);
          $remaingBalanceNode.removeClass('hidden');
        },
        onFailure: function () {
          setDefaultBtnState($this_form);
          $remaingBalanceNode.addClass('hidden');
          $error_node.removeClass('hidden');
        }
      });
    });
  };

  site.giftcards.balance = (function () {
    var options = {
      giftcardNumber: 0,
      giftcardPin: 0,
      errorListNode: null,
      onSuccess: function (balance) {},
      onFailure: function () {}
    };
    var successHandler = function (responseData) {
      options.onSuccess(responseData);
    };
    var failureHandler = function (responseData) {
      options.onFailure(responseData);
    };
    var getParams = function () {
      var params = {
        '_SUBMIT': 'giftcard_balance',
        'GC_GIFTCARD_NUMBER': options.giftcardNumber
      };

      // Loyalty giftcards do not require a pin.
      if (options.giftcardPin) {
        params.GC_GIFTCARD_PIN = options.giftcardPin;
      }

      return [params];
    };

    return {
      fetchBalance: function (args) {
        options = $.extend(options, args);
        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: getParams(),
          onSuccess: function (jsonRpcResponse) {
            var responseData = jsonRpcResponse.getData();

            successHandler(responseData);
          },
          onFailure: function (jsonRpcResponse) {
            var responseData = jsonRpcResponse.getMessages();

            if (args.ignoreGenericErrors) {
              failureHandler(responseData);
            } else {
              var errorObjectsArray = jsonRpcResponse.getMessages();

              generic.showErrors(errorObjectsArray, options.errorListNode);
              failureHandler(responseData);
            }
          }
        });
      }

    };
  })();

  Drupal.behaviors.giftBalanceForm = {
    attach: function (context, settings) {
      var $wrapperContext = $('.gift_balance_v1', context);

      site.giftcards.initCheckBalance($wrapperContext);
    }
  };
})(jQuery);
